/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShockEventsPerEntity
 */
export interface ShockEventsPerEntity {
    /**
     * 
     * @type {string}
     * @memberof ShockEventsPerEntity
     */
    entityId: string;
    /**
     * 
     * @type {string}
     * @memberof ShockEventsPerEntity
     */
    entityName: string;
    /**
     * 
     * @type {number}
     * @memberof ShockEventsPerEntity
     */
    severe: number;
    /**
     * 
     * @type {number}
     * @memberof ShockEventsPerEntity
     */
    medium: number;
    /**
     * 
     * @type {number}
     * @memberof ShockEventsPerEntity
     */
    light: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShockEventsPerEntity
     */
    chartData: Array<number>;
}

/**
 * Check if a given object implements the ShockEventsPerEntity interface.
 */
export function instanceOfShockEventsPerEntity(value: object): value is ShockEventsPerEntity {
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    if (!('entityName' in value) || value['entityName'] === undefined) return false;
    if (!('severe' in value) || value['severe'] === undefined) return false;
    if (!('medium' in value) || value['medium'] === undefined) return false;
    if (!('light' in value) || value['light'] === undefined) return false;
    if (!('chartData' in value) || value['chartData'] === undefined) return false;
    return true;
}

export function ShockEventsPerEntityFromJSON(json: any): ShockEventsPerEntity {
    return ShockEventsPerEntityFromJSONTyped(json, false);
}

export function ShockEventsPerEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShockEventsPerEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'entityId': json['entityId'],
        'entityName': json['entityName'],
        'severe': json['severe'],
        'medium': json['medium'],
        'light': json['light'],
        'chartData': json['chartData'],
    };
}

export function ShockEventsPerEntityToJSON(json: any): ShockEventsPerEntity {
    return ShockEventsPerEntityToJSONTyped(json, false);
}

export function ShockEventsPerEntityToJSONTyped(value?: ShockEventsPerEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityId': value['entityId'],
        'entityName': value['entityName'],
        'severe': value['severe'],
        'medium': value['medium'],
        'light': value['light'],
        'chartData': value['chartData'],
    };
}

